
<div class="cnt-box">
    <form [formGroup]="noteForm" (ngSubmit)="onSubmit()">
        <div class="flex flex-col">
            <div class="mb-4">
                <div class="flex"
                    [ngClass]="formUtils.hasValidationError(noteForm,'text') ? 'input-invalid' : 'input-white' ">
                    <!-- <div class="flex-prepend pl-2">
                        <label class="my-1 mr-2" for="inlineFormCustomSelectPref">Description</label>
                    </div> -->
                    <textarea class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary border-1" formControlName="text" rows="3" placeholder="Please enter your note here"></textarea>
                </div>
                <div *ngIf="formUtils.showValidationHint(noteForm,'text', 'required')"
                    class="input-hint">
                    {{ 'message.validation.required' | translate }}
                </div>
            </div>

            <!-- Action buttons-->
            <div class="flex justify-end">
        
                <!-- <div class="w-40">
                    <button type="button" (click)="onClickCancel()"
                        class="btn w-full border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-4 py-2 rounded-lg font-semibold transition-colors">Cancel
                    </button>
                </div> -->
                <div class="ml-3 w-20">
                    <button type="submit" [disabled]="isFormSubmit"
                        class="btn w-full px-4 py-2 rounded-lg font-semibold transition-colors bg-red-600 text-white hover:bg-red-700 ld-ext-right"
                        [ngClass]="{'running':isFormSubmit}">Add note
                        <div class="ld ld-ring ld-spin"></div>
                    </button>
                </div>

            </div>

        </div>
    </form>

    <!-- Notes view section -->
    <div class="mt-50" *ngIf="notes != null && notes.length > 0">
        
        <div *ngFor="let note of notes">
            <hr/>
            <div class="note-time">Note added: {{note.createdDatetime}}</div>
            <!-- <div>User Name</div> -->
            <div>{{note.text}}</div>
        </div>
    </div>

</div>
